/**
 * PERFORMANCE: Lazy load interaction-heavy features
 * Only loads scripts when user interacts with the feature
 * Expected improvement: -200ms to -400ms TBT
 */

(function() {
  'use strict';

  // Cart script loader
  function loadCartScripts() {
    if (window.cartScriptsLoaded) return;
    window.cartScriptsLoaded = true;

    const cartItemsSrc = document.querySelector('[data-cart-items-src]')?.dataset.cartItemsSrc;
    const cartDrawerSrc = document.querySelector('[data-cart-drawer-src]')?.dataset.cartDrawerSrc;

    if (cartItemsSrc) window.lazyLoadScript(cartItemsSrc, true);
    if (cartDrawerSrc) window.lazyLoadScript(cartDrawerSrc, true);
  }

  // Compare script loader
  function loadCompareScripts() {
    if (window.compareScriptsLoaded) return;
    window.compareScriptsLoaded = true;

    const compareDrawerSrc = document.querySelector('[data-compare-drawer-src]')?.dataset.compareDrawerSrc;
    const compareModalSrc = document.querySelector('[data-compare-modal-src]')?.dataset.compareModalSrc;

    if (compareDrawerSrc) window.lazyLoadScript(compareDrawerSrc, true);
    if (compareModalSrc) window.lazyLoadScript(compareModalSrc, true);
  }

  // Quick-add script loader
  function loadQuickAddScripts() {
    if (window.quickAddScriptsLoaded) return;
    window.quickAddScriptsLoaded = true;

    const quickAddSrc = document.querySelector('[data-quick-add-src]')?.dataset.quickAddSrc;
    if (quickAddSrc) window.lazyLoadScript(quickAddSrc, true);
  }

  // Load animation scripts after scroll or timeout
  function loadAnimationScripts() {
    if (window.animationScriptsLoaded) return;
    window.animationScriptsLoaded = true;

    const animationSrc = document.querySelector('[data-animation-src]')?.dataset.animationSrc;
    if (animationSrc) {
      const script = document.createElement('script');
      script.src = animationSrc;
      script.defer = true;
      document.head.appendChild(script);
    }

    document.removeEventListener('scroll', loadAnimationScripts);
  }

  // Event listeners for cart
  document.addEventListener('click', function(e) {
    if (e.target.closest('[href*="/cart"]') || e.target.closest('.js-open-cart')) {
      loadCartScripts();
    }
  }, { passive: true });

  // Event listeners for compare
  document.addEventListener('click', function(e) {
    if (e.target.closest('.js-compare') || e.target.closest('[data-compare]')) {
      loadCompareScripts();
    }
  }, { once: true, passive: true });

  // Event listeners for quick-add (desktop hover)
  if (window.matchMedia('(hover: hover)').matches) {
    document.addEventListener('mouseover', function(e) {
      if (e.target.closest('.js-quick-add')) {
        loadQuickAddScripts();
      }
    }, { once: true, passive: true });
  }

  // Animation loader - on scroll or after 2s
  if (document.body.classList.contains('cc-animate-enabled')) {
    document.addEventListener('scroll', loadAnimationScripts, { once: true, passive: true });
    setTimeout(loadAnimationScripts, 2000);
  }

})();
